module.exports = __webpack_public_path__ + "img/personajes.367ef4bf.jpg";